export const COMPONENT_NAME = "default-content";
